import React, { useState } from 'react';
import ThoughtsTab from '../components/community/ThoughtsTab';
import ShopTab from '../components/community/ShopTab';
import ShelvesTab from '../components/community/ShelvesTab';
import WatchListenTab from '../components/community/WatchListenTab';
import StatsTab from '../components/community/StatsTab';
import { useIsMobile } from '../hooks/useReaderCorner';

const C = { forestDark: '#1a3a2e', forest: '#2D4A3E', gold: '#d4a84b', cream: '#faf8f5' };

const TABS = [
  { id: 'thoughts', label: 'Thoughts',       emoji: '💭' },
  { id: 'shop',      label: 'Shop',           emoji: '🛍️' },
  { id: 'shelves',   label: 'Shelves',        emoji: '📚' },
  { id: 'watch',     label: 'Watch & Listen', emoji: '🎬' },
  { id: 'stats',     label: 'Community Stats', emoji: '📊' },
];

export default function ReaderCorner() {
  const [activeTab, setActiveTab] = useState('thoughts');
  const isMobile = useIsMobile();

  return (
    <div style={{ background: C.cream, minHeight: '100vh' }}>
      <style>{`.rc-hide-scrollbar::-webkit-scrollbar { display: none; }`}</style>

      {/* ── Header ── */}
      <div style={{ background: `linear-gradient(135deg, ${C.forestDark}, ${C.forest})`, padding: isMobile ? '28px 16px 60px' : '40px 20px 90px', textAlign: 'center', position: 'relative', zIndex: 1 }}>
        <h1 style={{ fontFamily: 'var(--font-display)', fontStyle: 'italic', fontSize: isMobile ? 30 : 44, margin: '0 0 6px', color: 'var(--brand-white)' }}>
          Reader's <span style={{ color: C.gold }}>Corner</span>
        </h1>
        <p style={{ fontFamily: 'var(--font-display)', fontStyle: 'italic', fontSize: isMobile ? 13 : 16, color: '#e5e0d8', margin: isMobile ? '0 0 20px' : '0 0 28px' }}>
          come yell about books with us
        </p>

        <div className="rc-hide-scrollbar" style={{
          display: 'flex', gap: 'var(--space-10)', justifyContent: isMobile ? 'flex-start' : 'center',
          flexWrap: isMobile ? 'nowrap' : 'wrap', overflowX: isMobile ? 'auto' : 'visible',
          maxWidth: 800, margin: '0 auto', padding: isMobile ? '0 4px 4px' : 0,
          WebkitOverflowScrolling: 'touch',
        }}>
          {TABS.map(tab => {
            const active = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: isMobile ? '9px 15px' : '11px 20px',
                  borderRadius: 'var(--radius-pill)',
                  fontSize: isMobile ? 12 : 13.5,
                  fontWeight: 700,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 'var(--space-6)',
                  flexShrink: 0,
                  whiteSpace: 'nowrap',
                  background: active ? C.gold : 'transparent',
                  color: active ? C.forestDark : 'var(--brand-white)',
                  border: active ? `1px solid ${C.gold}` : '1px solid rgba(255,255,255,0.35)',
                  transition: 'all 0.15s',
                }}
              >
                <span>{tab.emoji}</span> {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* ── Content ── */}
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: isMobile ? '16px 12px 40px' : '24px 20px 60px', position: 'relative', zIndex: 2 }}>
        {activeTab === 'thoughts' && <ThoughtsTab />}
        {activeTab === 'shop'      && <ShopTab />}
        {activeTab === 'shelves'   && <ShelvesTab />}
        {activeTab === 'watch'     && <WatchListenTab />}
        {activeTab === 'stats'     && <StatsTab />}
      </div>
    </div>
  );
}